/* ==========================================================================
   Silph TCG — page rachat : le plafond de photos doit se voir et se respecter.

   Deux garde-fous se superposent, et c'est voulu :

   · l'APPLICATION a son propre plafond (« Limite du nombre de fichiers »). Il
     est haut, volontairement : c'est un filet de sécurité, pas la règle. Elle
     coupe en silence, donc on ne veut pas qu'elle serve de limite visible ;
   · le SITE applique la vraie règle, celle annoncée au client. Tant qu'il y a
     trop de photos, l'envoi est bloqué et on lui dit combien en retirer. Il
     retire, le blocage tombe. Rien ne disparaît sans qu'il l'ait décidé.

   Si l'application coupe quand même (au-delà de son propre plafond, ou pour un
   poids ou un format), on le signale aussi — sinon des photos s'évaporent.
   ========================================================================== */

(function () {
  'use strict';

  var bloc = document.querySelector('.silph-rachat__app-form[data-photos-max]');
  if (!bloc) return;

  var maximum = parseInt(bloc.getAttribute('data-photos-max'), 10);
  var gabaritTrop = bloc.getAttribute('data-photos-message') || '';
  var gabaritRefus = bloc.getAttribute('data-photos-refus') || '';
  if (!(maximum > 0)) return;

  /* --- Lecture de l'état --------------------------------------------------
     L'application tient deux champs de fichiers : un champ de travail que le
     sélecteur remplit, et « file2[] » qui contient la liste retenue — celle
     qui part réellement. C'est celle-là qu'on compte. */

  function champRetenu() {
    return bloc.querySelector('input[type="file"][name="file2[]"]');
  }

  function nbPhotos() {
    var champ = champRetenu();
    return champ && champ.files ? champ.files.length : 0;
  }

  /* On accroche les messages au bloc du champ entier, pas à la zone de dépôt :
     celle-ci vit dans une rangée en flex, et un frère inséré à côté d'elle se
     retrouve en colonne à sa droite au lieu de passer dessous. */
  function blocDuChamp() {
    var zone = bloc.querySelector('.gfb__dropzone');
    return zone ? zone.closest('.globo-form-control') || zone.parentNode : null;
  }

  function formulaire() {
    return bloc.querySelector('form');
  }

  function boutonEnvoi() {
    var f = formulaire();
    return f ? f.querySelector('button[type="submit"]') : null;
  }

  function remplir(gabarit, nombres) {
    return gabarit
      .replace(/\{max\}/g, nombres.max)
      .replace(/\{n\}/g, nombres.n)
      .replace(/\{trop\}/g, nombres.trop);
  }

  /* --- Affichage ----------------------------------------------------------- */

  var avis = null;

  function avisElement() {
    if (!avis) {
      avis = document.createElement('p');
      avis.className = 'silph-rachat__photos-avis';
      avis.setAttribute('role', 'status');
    }
    return avis;
  }

  function afficher(texte, bloquant) {
    var champ = blocDuChamp();
    if (!champ || !texte) return;
    var element = avisElement();
    element.textContent = texte;
    element.classList.toggle('silph-rachat__photos-avis--bloquant', !!bloquant);
    if (element.parentNode !== champ) champ.appendChild(element);
  }

  function masquer() {
    if (avis && avis.parentNode) avis.parentNode.removeChild(avis);
  }

  /* Le bouton n'est pas désactivé pour de bon : un bouton grisé qui ne dit rien
     laisse le client sans explication, et si ce script cassait un jour, plus
     personne ne pourrait envoyer. Il est marqué visuellement, et c'est
     l'interception de l'envoi ci-dessous qui fait réellement barrage. */
  function marquerBouton(bloquer) {
    var bouton = boutonEnvoi();
    if (!bouton) return;
    bouton.classList.toggle('silph-rachat__envoi--bloque', bloquer);
    if (bloquer) bouton.setAttribute('aria-disabled', 'true');
    else bouton.removeAttribute('aria-disabled');
  }

  /* --- Règle --------------------------------------------------------------- */

  /* Dernier compte connu : il sert à reconnaître un RETRAIT. Après un retrait,
     tout message affiché est périmé — y compris « certaines photos n'ont pas pu
     être ajoutées », qui parlait de la sélection précédente. */
  var dernierCompte = 0;

  function evaluer() {
    var n = nbPhotos();
    var retrait = n < dernierCompte;
    dernierCompte = n;

    if (n > maximum) {
      afficher(remplir(gabaritTrop, { n: n, max: maximum, trop: n - maximum }), true);
      marquerBouton(true);
      return true;
    }
    marquerBouton(false);
    if (retrait || (avis && avis.classList.contains('silph-rachat__photos-avis--bloquant'))) {
      masquer();
    }
    return false;
  }

  /* --- L'application a coupé toute seule ----------------------------------
     Phase de capture : on passe avant ses écouteurs, donc le compte lu ici est
     bien celui d'AVANT son traitement. La différence entre ce que le client a
     choisi et ce qui a été ajouté dit si des photos se sont évaporées. */
  document.addEventListener(
    'change',
    function (evenement) {
      var champ = evenement.target;
      if (!champ || champ.tagName !== 'INPUT' || champ.type !== 'file') return;
      if (!bloc.contains(champ)) return;

      var demandees = champ.files ? champ.files.length : 0;
      if (!demandees) return;
      var avant = nbPhotos();

      /* L'application lit les fichiers de façon asynchrone (vignettes, contrôle
         du poids). On laisse passer quelques images avant de comparer. */
      window.setTimeout(function () {
        var prises = nbPhotos() - avant;
        if (evaluer()) return; // le blocage prime, il est plus utile à lire
        /* Quand le client enlève une vignette, l'application redéfinit elle-même le
           champ retenu, et ça déclenche un « change » qui ressemble à s'y méprendre
           à une sélection : la liste « demandée » est alors la liste déjà en place,
           et rien n'a bougé. Deux garde-fous : `prises` négatif (la liste a rétréci)
           et le cas où le compte est identique avant et après. Un retrait n'est pas
           un refus, on ne dit rien. */
        var rienNaBouge = prises === 0 && demandees === avant;
        if (!rienNaBouge && prises >= 0 && prises < demandees && gabaritRefus) {
          afficher(remplir(gabaritRefus, { n: nbPhotos(), max: maximum, trop: demandees - prises }), false);
        }
      }, 400);
    },
    true
  );

  /* --- Barrage à l'envoi ---------------------------------------------------
     En capture sur le document : on passe avant l'écouteur de l'application,
     qui part sinon en requête réseau. */
  document.addEventListener(
    'submit',
    function (evenement) {
      if (!bloc.contains(evenement.target)) return;
      if (nbPhotos() <= maximum) return;
      evenement.preventDefault();
      evenement.stopImmediatePropagation();
      evaluer();
      if (avis) avis.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  /* Filet : certaines versions de l'application envoient depuis le clic du
     bouton plutôt que depuis l'événement d'envoi du formulaire. */
  document.addEventListener(
    'click',
    function (evenement) {
      var bouton = evenement.target.closest ? evenement.target.closest('button[type="submit"]') : null;
      if (!bouton || !bloc.contains(bouton)) return;
      if (nbPhotos() <= maximum) return;
      evenement.preventDefault();
      evenement.stopImmediatePropagation();
      evaluer();
      if (avis) avis.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  /* --- Suivi en direct -----------------------------------------------------
     Ajouter ou retirer une photo doit mettre le message à jour tout de suite.
     On observe le bloc du champ plutôt que d'écouter chaque croix : elles sont
     recréées à chaque rendu, et la liste est mise à jour avec un délai qu'on ne
     maîtrise pas. */
  function surveiller() {
    var champ = blocDuChamp();
    if (!champ || !window.MutationObserver) return false;
    var enCours = false;
    new MutationObserver(function () {
      if (enCours) return; // nos propres insertions ne doivent pas relancer la boucle
      enCours = true;
      window.setTimeout(function () {
        enCours = false;
        evaluer();
      }, 60);
    }).observe(champ, { childList: true, subtree: true });
    return true;
  }

  /* Le formulaire est monté par l'application, après ce script. On attend qu'il
     existe, sans boucler indéfiniment si l'application ne se charge pas. */
  var essais = 0;
  var attente = window.setInterval(function () {
    essais += 1;
    if (surveiller() || essais > 60) window.clearInterval(attente);
  }, 500);
})();
